/* Edaliya — thema-interacties */
(function(){
  "use strict";

  /* Hero-carrousel */
  function initHero(root){
    var slides = root.querySelectorAll('.slide'),
        dots   = root.querySelectorAll('.hero-dots button'),
        cur = 0, timer = null;
    if (slides.length < 2) return;
    function show(i){
      cur = (i + slides.length) % slides.length;
      slides.forEach(function(s,n){ s.classList.toggle('on', n === cur); });
      dots.forEach(function(d,n){ d.classList.toggle('on', n === cur); });
    }
    function play(){ stop(); timer = setInterval(function(){ show(cur+1); }, 5500); }
    function stop(){ if (timer) clearInterval(timer); }
    dots.forEach(function(d){ d.addEventListener('click', function(){ show(+d.dataset.i); play(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    var x0 = null;
    root.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
    root.addEventListener('touchend', function(e){
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { show(cur + (dx < 0 ? 1 : -1)); play(); }
      x0 = null;
    }, {passive:true});
    play();
  }

  /* Menu-lade */
  function initDrawer(){
    var drawer = document.getElementById('drawer'),
        scrim  = document.getElementById('scrim'),
        burger = document.getElementById('burger'),
        close  = document.getElementById('closeDrawer');
    if (!drawer || !burger) return;
    function openM(){ drawer.classList.add('open'); scrim.classList.add('on');
      drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
    function closeM(){ drawer.classList.remove('open'); scrim.classList.remove('on');
      drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
    burger.addEventListener('click', openM);
    if (close) close.addEventListener('click', closeM);
    if (scrim) scrim.addEventListener('click', closeM);
    drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeM); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeM(); });
  }

  /* FAQ-accordeon */
  function initFaq(){
    document.querySelectorAll('.faq-item').forEach(function(item){
      var q = item.querySelector('.faq-q'), a = item.querySelector('.faq-a');
      if (!q || !a || q.dataset.bound) return;
      q.dataset.bound = '1';
      q.addEventListener('click', function(){
        var wasOpen = item.classList.contains('open');
        var list = item.closest('.faq-list') || document;
        list.querySelectorAll('.faq-item.open').forEach(function(o){
          o.classList.remove('open'); o.querySelector('.faq-a').style.maxHeight = null;
        });
        if (!wasOpen){ item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  }

  /* Footer-kolommen inklapbaar op mobiel */
  function initFooter(){
    var mq = window.matchMedia('(max-width:1000px)');
    document.querySelectorAll('.f-col:not(.f-brand)').forEach(function(col){
      var h = col.querySelector('h4'), body = col.querySelector('.f-body');
      if (!h || !body || h.dataset.bound) return;
      h.dataset.bound = '1';
      h.addEventListener('click', function(){
        if (!mq.matches) return;
        var wasOpen = col.classList.contains('open');
        col.classList.toggle('open', !wasOpen);
        body.style.maxHeight = wasOpen ? null : body.scrollHeight + 'px';
      });
    });
    function sync(){
      document.querySelectorAll('.f-col:not(.f-brand) .f-body').forEach(function(b){
        if (!mq.matches){ b.style.maxHeight = ''; b.parentElement.classList.remove('open'); }
        else if (!b.parentElement.classList.contains('open')){ b.style.maxHeight = null; }
      });
    }
    mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
    sync();
  }

  /* Reveal bij scrollen */
  function initReveal(){
    var els = document.querySelectorAll('.rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function(el){ el.classList.add('in'); }); return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:.1, rootMargin:'0px 0px -50px 0px'});
    els.forEach(function(el){ io.observe(el); });
  }

  /* Anker-scroll met headercompensatie */
  function initAnchors(){
    document.querySelectorAll('a[href^="#"]').forEach(function(a){
      if (a.dataset.bound) return;
      a.dataset.bound = '1';
      a.addEventListener('click', function(e){
        var id = a.getAttribute('href');
        if (id.length < 2) return;
        var t = document.querySelector(id);
        if (!t) return;
        e.preventDefault();
        var h = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--hdr')) || 74;
        window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - h, behavior:'smooth' });
      });
    });
  }

  function boot(){
    document.querySelectorAll('.hero').forEach(initHero);
    initDrawer(); initFaq(); initFooter(); initReveal(); initAnchors();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();

  /* Theme-editor: opnieuw initialiseren na sectie-updates */
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
